import React, {useContext, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {Select} from "@mui/material";
import firebase from "../../firebase/firebase";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuItem from "@mui/material/MenuItem";
import InputBase from "@mui/material/InputBase";

import PostNotification from "../../helpers/post-notification";
import {AuthUserContext} from "../../providers/AuthProvider";
import PostActivity from "../../helpers/post-activity";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#F1F4F8',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 30,
    position: 'relative',
    backgroundColor: '#204488',
    border: 'none',
    fontSize: 16,
    width: 80,
    color: '#fff',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 30,
      borderColor: 'none',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));


export default function ManageProjectsMilestones({payments,project, projectId, milestone, parentCallback}){
  const {profile} = useContext(AuthUserContext);

  const [milestones, setMiles] = React.useState([])
  React.useEffect(()=> {
    if (milestone) {

      setMiles(milestone)
    }
  }, [milestone])

  const dateConverter = (date) => {
    const [year, month, day] = date.split('-');

    const result = `${month}/${day}/${year}`;
    return result
  }
  
  return (

    <TableContainer >
      <Table sx={{ minWidth: 700 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16, }}>Description</StyledTableCell>
            <StyledTableCell  align="center"  sx={{fontWeight: 'bolder', fontSize:16, }}>Amount</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Date</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Milestone status</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Bank details</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Payment status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {milestones?.length > 0 && milestones.map((row, i) => (
            <StyledTableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell  component="th" scope="row"><Typography noWrap={true}>{row?.description}</Typography></StyledTableCell>
              <StyledTableCell   align="center"><Typography noWrap={true}>{row?.amount}</Typography></StyledTableCell>
              <StyledTableCell   align="center"><Typography noWrap={true}>{dateConverter(row?.deadLine)}</Typography></StyledTableCell>
              <StyledTableCell   align="center"><Typography noWrap={true}>{row?.status ? row?.status : 'Yet to start'}</Typography></StyledTableCell>
              <StyledTableCell   align="center"><Button variant={'text'} sx={{textDecoration: 'underline'}} onClick={() => parentCallback(true)}>View</Button></StyledTableCell>
              <StyledTableCell align="center">

                <Select value={row?.paymentStatus ? row?.paymentStatus : 'pending'} multiple={false} 
                style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",paddingLeft:"10px",paddingRight:"10px",width:"172px",height:"50px"}}
                 IconComponent={() => <ArrowDropDownIcon  />}
                 onChange={async (e) => {
                   debugger
                  const p = [...milestones];
                  p[i].paymentStatus = e.target.value;
                  setMiles(p)
                  await firebase
                    .firestore()
                    .collection('projects')
                    .doc(projectId.projectId)
                    .update({contract: {...projectId?.contract, millstones:p}})

                  if (e.target.value === 'transferred') {

                    await PostActivity({
                      text: `"${profile.name}" ${profile?.super === true ? 'super admin' : 'admin'}
                          X super admin has transferred amount`,
                      uid: profile.uid,
                      createdBy:profile?.uid
                    }).then()
                    await PostNotification({
                      title: 'Payment Update',
                      text:`${p[i].amount || 0} amount has been transferred 
                           into your bank account on completion of ${p[i].description || ''} milestone for project ${project?.title || ''}`,
                      uid: project?.uid,
                      createdBy:profile.uid,
                      link: '/creator/project-details/' + project.id,
                    }).then();

                    if (payments.length > 0) {
                      /*
                      * get unique uid
                      * */
                      const ids = new Set(payments.map((p) => p.createdBy));
                      const uuids = [...ids]
                      /*
                      * end
                      * */
                      for (let uid of uuids) {
                        await PostNotification({
                          title: 'Payment Update',
                          text: `${p[i].amount || 0} amount has been released
                           into creator’s bank account on completion of ${p[i].description || ''} milestone for project ${project?.title || ''}`,
                          uid: uid,
                          createdBy:profile?.uid,
                          link: `/investor/project-show-interest/${project.id}`,
                        })
                      }
                    }


                  }

                }}>

                  <MenuItem value={'pending'}>
                    Pending
                  </MenuItem>
                  <MenuItem value={'transferred'}>
                    Transferred
                  </MenuItem>
                </Select>


              </StyledTableCell>

            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}